<div id="button-container" [ngStyle]="{'min-height.px': showAlways ? 75 : null}">
  <div class="button-wrapper text-unselectable bg-white pl-1 pr-1" id="button-wrapper" 
    [ngClass]="{
    'screen-blur': currentCartStatus !== 'LOADED', 
    'd-none': !basketEnabled && !isAdminOrderCaptureUpdate,
    'show-always-view': showAlways,
    'regular-view': !showAlways,
    'p-1': showStandalonePaymentButton() || showViewOrderWithValueButton() || showViewOrderWithoutValueButton()
    }" 
    [ngStyle]="{
      'bottom.px': isGoApp ? customerFooterHeight+cookieBarHeight : cookieBarHeight, 
      'max-width.px': elementWidth > 0 && showAlways ? elementWidth : null,
      'visibility': (showStandalonePaymentButton() || showViewOrderWithValueButton() || showViewOrderWithoutValueButton()) ? 'visible' : 'hidden'
    }"
    *ngIf="selectedCatalog !== -1">
    <span *ngIf="showStandalonePaymentButton()"
      class="payOnline d-flex py-3 mt-2 justify-content-center align-items-center text-center font-size-primary text-unselectable w-100 mobile-button dark"
      (click)="onPayOnline()">
      {{'public.standalonepayment.paymentpage.title' | translate}}
    </span>
    <div>
      <a href="#" (click)="currentCartStatus === 'LOADED' && onViewOrder($event)"
        class="button dark d-block text-center py-3 mx-2 mt-2 font-size-primary text-unselectable"
        [attr.data-cart-items]="totalQuantity"
        [attr.data-cart-total]="cartItemsTotalValue | formatPrice: selectedStoreLocale:selectedStoreCurrency: selectedStoreCurrencySymbol "
        [attr.data-cart-currency]="" *ngIf="showViewOrderWithValueButton()">
        {{'public.global.viewOrder' | translate}}
      </a>
      <a href="#" (click)="currentCartStatus === 'LOADED' && onViewOrder($event)"
        class="button dark d-block text-center py-3 mx-2 mt-2 font-size-primary text-unselectable"
        [attr.data-cart-items]="cartItems.length" [attr.data-cart-currency]=""
        *ngIf="showViewOrderWithoutValueButton()">
        {{'public.global.viewOrder' | translate}}
      </a>
      <p *ngIf="!acceptTermVisible" [ngClass]="{'d-none': cartItems}"
        class="font-size-secondary text-center mb-0 py-1 bg-white">{{'public.global.poweredByGonnaOrder' | translate}}
      </p>
    </div>
  </div>
</div>